import React, { useState, useEffect } from 'react';
import { isNotEmpty } from '../../lib/ep';

import PreviewWrapper from './PreviewWrapper';
import PreviewWrapperNotBuilder from './PreviewWrapperNotBuilder';

const BuilderCanvas = (props) => {
	const [ is_loading, setIsLoading ] = useState(true);

	const is_adaptable = props?.is_adaptable ?? true;
	const not_awesome = props?.not_awesome ?? false;
	const preview_type = props?.preview_type ?? 'full';
	const add_public_css_vars = props?.add_public_css_vars ?? !not_awesome;
	const prevent_overflow = props?.prevent_overflow ?? false;

	const ensureInit = (cb) => {
		if(!window.builder_loaded) {
			setTimeout(() => {
				ensureInit(cb);
			}, 50);
		} else {
			cb();
		}
	};

	useEffect(() => {
		ensureInit(() => { setIsLoading(false); });
	}, []);

	var container_styles = {};
	if(props.container_w != undefined) container_styles.width = props.container_w;
	if(props.container_h != undefined) container_styles.height = props.container_h;

	let PreviewItem;
	let is_fullscreen = null;
	switch(preview_type) {
		case 'mobile':
			PreviewItem = PreviewWrapperNotBuilder;
			is_fullscreen = true;
			break;

		case 'full':
		default:
			PreviewItem = PreviewWrapper;
			break;
	}

	const container_classes = ['content_builder'];
	if(isNotEmpty(props, 'extra_classes')) container_classes.push(props.extra_classes);
	if(not_awesome) container_classes.push('not_awesome');
	if(is_adaptable) container_classes.push('is_adaptable gui_is_not_padded');

	const content_classes = ['gui_pos_rel', ((is_adaptable) ? 'adapt_this' : 'full_adaptable_container')];
	if(prevent_overflow) content_classes.push('gui_hidden_overflowed');
	if(props.content_classes) content_classes.push(props.content_classes);
	
	const preview_classes = [];
	if(add_public_css_vars) preview_classes.push('css_var_root');

	const c_class = ['gui_preview_full_container', `is_${window?.text_direction ?? 'ltr'}`];
	if(props.enable_actions != undefined && props.enable_actions) c_class.push('with_tooltips');

	return (
		<div class={container_classes.join(" ")}>
			{(props.off_content != undefined) && (
				<aside class="extra_content gui_is_padded gui_padded_in_bottom" style={{height:'auto'}}>
					{props.off_content}
				</aside>
			)}

			<PreviewItem
				use_this={is_adaptable}
				is_fullscreen={is_fullscreen}
				bordered={props.bordered}
				not_bordered={props.not_bordered}
				_class={preview_classes.join(" ")}
			>
				<section class={content_classes.join(" ")}>
					<div id="promo_bg_builder" />

					{(!is_loading) && (
						<div class={c_class.join(" ")} style={(props._bg_styles != undefined) ? props._bg_styles : null}>
							{props.children}
						</div>
					)}
				</section>
			</PreviewItem>
		</div>
	);
};

export default BuilderCanvas;